import usePrivateAxios from "@/common/api/usePrivateAxios";
import { BillResumeData, BillResumeResponse } from "@/features/billingBills/types/bills.type";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

type useBillingBillProps = {
  id?: string;
  enabled?: boolean;
};

type useBillingBillType = ({ id }: useBillingBillProps) => UseQueryResult<BillResumeData, unknown>;

const useBillingBill: useBillingBillType = ({ id, enabled = true }) => {
  const privateAxios = usePrivateAxios();

  return useQuery<BillResumeResponse, unknown, BillResumeData>({
    queryKey: ['billingBill', id],
    queryFn: () => {
      return privateAxios.get(`/billing/bills/${id}`);
    },
    enabled,
    refetchInterval: 60 * 1000,
    select: (data) => data?.data?.data,
  });
};

export default useBillingBill;
